/**模板路由 */
export default {
    name: 'formwork',
    path: 'formwork',
    meta: {
        title: '模板管理'
    },
    component: () => import('@/pages/index.vue'),
    children: [
        {
            name: 'formwork-query',
            path: 'query',
            meta: { title: '查询模板' },
            component: () => import('@/pages/formwork/query.vue'),
        },
        {
            name: 'formwork-product',
            path: 'product',
            meta: { title: '产品模板' },
            component: () => import('@/pages/formwork/product.vue')
        },
        {
            name: 'formwork-diy',
            path: 'diy',
            meta: { title: 'DIY模板' },
            component: () => import('@/pages/formwork/diy.vue')
        },
        {
            name: 'formwork-editDiy',
            path: 'editDiy',
            meta: { title: '编辑模板' },
            component: () => import('@/pages/formwork/editDiy.vue')
        },
    ]
}